module.exports = __webpack_public_path__ + "static/media/suicidePreventionResourceCenter.9c50e996.jpg";